
import * as React from "react";
import Header from "../../Header";
import Footer from "../../Footer";
import { IUserListItem } from "../../../interfaces/IUser";
import EditUser from "./EditUser";
import { Api } from "../../../lib/Api";
import LoaderComp from "../../../../avernus/loader/source/LoaderComp";

interface IUserListProps {
    setUrl       : any
    urlPrefix    : string
    restaurantId?: number
}

interface IUserListState {
    userItems   : Array<IUserListItem>
    openedUserId: number
    version     : number
    filter      : string
}

interface IGetListResult {
    items:Array<IUserListItem>
}

export default class UserList extends React.Component<IUserListProps, IUserListState>{

    private restaurantId:number;

    constructor(props:IUserListProps){
        super(props);
        this.state = {
            version     : 0,
            userItems   : null,
            openedUserId: null,
            filter      : ''
        };
        this.restaurantId = null;
        if ( this.props.restaurantId !== undefined ) {
            this.restaurantId = this.props.restaurantId;
        }
        this.init();
    }

    private init(){
        Api.call(this.props.urlPrefix+'/users/getListForTable', {
            restaurantId: this.restaurantId
        }, (result:IGetListResult)=>{
            console.log(result.items);
            this.setState({
                userItems: result.items,
                version: (this.state.version + 1)
            });
        });
    }

    private addNewUserBtnClickHandler(evt): void {
        evt.preventDefault();
        this.setState({
            openedUserId: 0
        });
    }

    private editUserBtnClickHandler(evt, id:number): void {
        evt.preventDefault();
        this.setState({
            openedUserId: id
        });
    }

    private removeUserBtnClickHandler(evt, id:number, userName:string): void {
        evt.preventDefault();
        this.setState({
            openedUserId: null
        }, () =>{
            // remove
            if (window.confirm("Are you sure want to delete this \""+userName+"\" user?")) {
            Api.call(this.props.urlPrefix + '/users/removeUser', {
                id: id,
                restaurantId: this.restaurantId
                }, (result)=>{
                this.init(); // reload
            });
        }
        });
    }



    render() {
        let title = 'Users';
        if ( this.state.openedUserId !== null ) {
            title = 'Add new user';
            if ( this.state.openedUserId > 0 ) {
                title = "Modify user"
            }
        }
        return (
            <div id="restaurant_userlist">
                <Header
                    title = {title}
                    setUrl={this.props.setUrl}
                />
                <div className="container content_section">
                    <div className = "h1_box">
                        <h1>{title}</h1>
                    </div>
                    { this.state.openedUserId !== null?<EditUser urlPrefix={this.props.urlPrefix} id={this.state.openedUserId} key={'user_form_' + this.state.openedUserId}  changed={(close) => {
                        if (close === true) {
                            this.setState({
                                openedUserId: null
                            }, () => {
                                this.init();
                            });
                        } else {
                            this.init();
                        }

                        }}
                        disabledRemoveBtn={this.state.openedUserId === Api.getUser().id}
                        restaurantId={this.restaurantId}
                        />:this.UserListSection() }

                </div>
                <Footer setUrl={this.props.setUrl}/>
			</div>
        );
    }

    private changeFilterHandler(evt): void {
        evt.preventDefault();
        this.setState({
            filter: evt.target.value
        });
    }


    private UserListSection() {
        let currentUserId = Api.getUser().id;
        let adminMode:boolean = Api.getPermission() === 'superadmin';
        return <section className="user_list">
            {this.state.userItems === null ? <div className="loading_row">
                <LoaderComp show={true} />
            </div> : <>
            {adminMode?<>
            <div className="form-row" style={{padding: '10px'}}>
                <div className="col sfc">
                    <input type="text" className="s-form-control" placeholder="Search..." value={ this.state.filter } onChange={ (e) => this.changeFilterHandler(e) } />
                </div>
            </div>
            </>:''}
            { this.state.userItems.map((item, index) => {
                return <div className="row user_row" key={index} id={'user_row_'+item.id}>
                    <div className="col-4 align-self-start profile-pic" onClick={e => this.editUserBtnClickHandler(e, item.id)}>
                        {
                            item.photos['profilePhoto'].length > 0 ?
                                <img src={item.photos['profilePhoto']} width="100px" height="100px" /> :
                                <img src="img/service/icons/create_user_default_photo.svg" width="100px" height="100px" alt="" />
                        }
                    </div>
                    <div className="col align-self-center" onClick={e => this.editUserBtnClickHandler(e, item.id)}>
                        <p className = "name">{item.fullName}</p>
                        { adminMode?<sup className="status_box">
                            { item.status }
                        </sup>:'' }
                    </div>
                    <div className="align-self-center" onClick={e => this.editUserBtnClickHandler(e, item.id)}>
                        <a className="btn btn-link table_edit_btn u_edit" role="button"></a>
                    </div>
                    { currentUserId !== item.id?<div className="align-self-center table_remove_btn" onClick={e => this.removeUserBtnClickHandler(e, item.id, item.userName)}>
                        <a className="btn btn-link u_trash" role="button"></a>
                    </div>:'' }


                </div>;
            })}
            <div className = "row create_user_button">
                <div className = "col-4">
                    <img src="img/service/icons/create_user_default_photo.svg" width={70} alt="" />
                </div>
                <div className = "col align-self-center">
                    <p className = "label">New User</p>
                </div>
                <div className = "col align-self-center">
                    <div className="float-right mr-3" onClick={(e) => { this.addNewUserBtnClickHandler(e); } }>
                        <a className="btn add_new_user_btn" id="add_new_user_btn" role="button"/>
                    </div>
                </div>
            </div>
            </>}
        </section>;
    }
}
